import { createContext, useContext } from "react";

export const ScrollContainerContext = createContext<HTMLElement | null>(null);

/** The element that actually scrolls page content inside AppShell/DashboardShell (not window). */
export function useScrollContainer(): HTMLElement | null {
  return useContext(ScrollContainerContext);
}
